import React from 'react';
import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { InfoTooltip } from '../Tooltips';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/const';
import { formatCurrencyBasedOnCountryCode } from 'src/utils/functions';
import { useSelector } from 'react-redux';

export const MapListingCountInfoBox = ({
  listingsLength,
  otaListingsLength,
  isMapChanging,
  multipleMarkersCallLoading,
}: {
  listingsLength: number;
  otaListingsLength: number;
  isMapChanging: boolean;
  multipleMarkersCallLoading: boolean;
}) => {
  const search = useSelector(state => (state as any).dashboard.search);
  return multipleMarkersCallLoading ? (
    <Box
      sx={{
        marginRight: '10px',
        background: '#0008',
        padding: '5px 10px',
        position: 'absolute',
        top: '25px',
        left: '7px',
        zIndex: 3,
        backdropFilter: 'blur(4px)',
        overflow: 'hidden',
        height: 'auto',
        borderRadius: 4,
      }}
    >
      <Typography variant="body2" style={{ color: '#fff' }}>
        Fetching listings {search.data ? 'in ' + search.data.name : ''}... Please wait while we
        gather the latest data <CircularProgress size={20} sx={{ color: 'white' }} />
      </Typography>
    </Box>
  ) : (
    <Box
      sx={{
        marginRight: '10px',
        background: '#0008',
        borderRadius: 4,
        padding: '5px 10px',
        position: 'absolute',
        top: '25px',
        left: '7px',
        zIndex: 3,
        backdropFilter: 'blur(4px)',
        height: '20px',
        overflow: 'hidden',
        // transition: 'height 0.25s ease, border-radius 0.25s ease',
        // '&:hover': {
        //   height: '42px',
        //   borderRadius: 2,
        // },
      }}
    >
      <Typography variant="body2" style={{ color: '#fff' }}>
        <div>
          {isMapChanging ? (
            <CircularProgress size={10} color={'inherit'} thickness={10} />
          ) : (
            formatCurrencyBasedOnCountryCode(listingsLength, 'USD')
          )}{' '}
          Airbnb listings are available in this area. Zoom in to see.
        </div>
      </Typography>

      {/* <Typography variant="body2" style={{ color: '#fff', marginTop: '2px' }}>
        <div>
          {isMapChanging ? (
            <CircularProgress size={10} color={'inherit'} thickness={10} />
          ) : (
            formatCurrencyBasedOnCountryCode(otaListingsLength, 'USD')
          )}{' '}
          VRBO, Booking.com, and Tripadvisor listings are available in this area
        </div>
      </Typography> */}
    </Box>
  );
};
